/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA review sidedrawer (inbox)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsReviewRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'inbox.reviews.review',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(InboxReviewsReviewRoute);
